import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

/**
 * A Card that reports the cursor position to CSS as --mx / --my, which the
 * .spotlight utility turns into a soft gold wash following the pointer.
 *
 * Pure decoration: strip the handler and the card still renders identically,
 * just unlit. It is also invisible to anyone navigating by keyboard, which is
 * why nothing is ever communicated by it alone.
 */
export function SpotlightCard({
  className,
  children,
  ...props
}: React.ComponentProps<typeof Card>) {
  const onMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
  };
  return (
    <Card
      className={cn("spotlight", className)}
      onMouseMove={onMouseMove}
      {...props}
    >
      {children}
    </Card>
  );
}
